import {AppServices} from "../../config/entities";
import {IPaymentOffsetAvailablePayment} from "../../dtos/paymentOffset/IPaymentOffsetAvailablePayment";

export class PaymentOffsetService {
    async getVendorPaymentOffset(documentId: string) : Promise<IPaymentOffsetAvailablePayment[]> {
        const url = `/PaymentOffsets/vendor`;
        const body = {
            documentId: documentId
        }
        const response = await AppServices.Axios.post<IPaymentOffsetAvailablePayment[]>(url, body);
        return response.data;
    }
    
    async getCustomerPaymentOffset(documentId: string) {
        const url = `/PaymentOffsets/customer/${documentId}`;
        const response = await AppServices.Axios.get(url);
        return response.data;
    }
}